import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  fetchGlobalUsers,
  getGlobalUsersCalled,
  getGlobalUsersRecord,
  getGlobalUsersRefresh,
} from '../globalList';

const useAllUsers = () => {
  const users = useSelector(state => getGlobalUsersRecord(state));
  const hasBeenCalled = useSelector(state => getGlobalUsersCalled(state));
  const forceRefresh = useSelector(state => getGlobalUsersRefresh(state));
  const dispatch = useDispatch();

  useEffect(() => {
    if ((isEmpty(users) && !hasBeenCalled) || forceRefresh) {
      dispatch(fetchGlobalUsers());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [Object.keys(users).length, dispatch, hasBeenCalled, forceRefresh]);
  return { users, hasBeenCalled, refresh: forceRefresh };
};

export default useAllUsers;
